export default "__VITE_ASSET__nG5$bRyq__"